import React from 'react';

const OutcomesSection = () => {
  return (
    <section className="outcomes-section">
      <div className="outcomes-inner">
        <p className="section-eyebrow">What You Walk Away With</p>
        <h2 className="section-title">Six outcomes. <em>One decisive advantage.</em></h2>
        <div className="outcomes-grid">
          <div className="oc">
            <div className="oc-icon">🎯</div>
            <div>
              <h3 className="oc-title">Personal &amp; Business Readiness</h3>
              <p className="oc-text">A clear-eyed assessment of your emotional, financial, and professional readiness — plus your Magic Number, the after-tax amount that defines when to say yes.</p>
            </div>
          </div>
          <div className="oc">
            <div className="oc-icon">📊</div>
            <div>
              <h3 className="oc-title">Tracked Valuation Uplift</h3>
              <p className="oc-text">A live M&A Readiness Index and estimated valuation impact — showing exactly how much value you've built as you complete each action in the Dashboard.</p>
            </div>
          </div>
          <div className="oc">
            <div className="oc-icon">🗺️</div>
            <div>
              <h3 className="oc-title">Buyer Intelligence</h3>
              <p className="oc-text">Deep knowledge of every buyer type, what drives their decisions, how to position your company for each, and how to answer the questions behind the questions.</p>
            </div>
          </div>
          <div className="oc">
            <div className="oc-icon">🏛️</div>
            <div>
              <h3 className="oc-title">Audit-Ready Data Room</h3>
              <p className="oc-text">A complete iVDR with real-time gap detection, red flag alerts, granular access control, and integrated messaging — everything tracked, timestamped, and audit-ready.</p>
            </div>
          </div>
          <div className="oc">
            <div className="oc-icon">📋</div>
            <div>
              <h3 className="oc-title">Market-Ready Documents</h3>
              <p className="oc-text">Your Blind Profile, CIM, NDA, and buyer targeting list — professionally crafted, data-room-aligned, and built around your specific value story.</p>
            </div>
          </div>
          <div className="oc">
            <div className="oc-icon">🤝</div>
            <div>
              <h3 className="oc-title">End-to-End Process Advisory</h3>
              <p className="oc-text">A full M&A advisor — managing buyer outreach, management meetings, IOI and LOI negotiations, and offer evaluation all the way to the closing table.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OutcomesSection;
